import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { DeliveryAddressApi } from 'api';
import type { DeliveryAddress } from 'api/methods/DeliveryAddressApi';

/**
 * [DeliveryAddress] Query key 생성
 * --
 */
export const deliveryAddressQueryKeys = createQueryKeys('deliveryaddress', {
  getDeliveryAddress: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getDeliveryAddresses: (params?: { [key: string]: string | number }) => [
    params,
  ],
});

/**
 * [DeliveryAddress] 배달 주소 전체 조회
 * --
 */
export const useGetDeliveryAddresses = (
  params?: { [key: string]: string | number },
  option?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: deliveryAddressQueryKeys.getDeliveryAddresses(params).queryKey,
    queryFn: () => DeliveryAddressApi.getDeliveryAddresses(params),
    ...option,
  });
  return data;
};

/**
 * [DeliveryAddress] 배달 주소 상세 조회
 * --
 */
export const useGetDeliveryAddress = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: deliveryAddressQueryKeys.getDeliveryAddress(idx, params).queryKey,
    queryFn: () => DeliveryAddressApi.getDeliveryAddress(idx, params),
  });

  return data;
};

/**
 * [DeliveryAddress] 배달 주소 생성
 * --
 */
export const useCreateDeliveryAddress = (body: DeliveryAddress) => {
  const { mutateAsync: createDeliveryAddress, ...result } = useMutation({
    mutationFn: (variables: DeliveryAddress) =>
      DeliveryAddressApi.createDeliveryAddress(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createDeliveryAddress, ...result };
};

/**
 * [DeliveryAddress] 배달 주소 수정
 * --
 */
export const useUpdateDeliveryAddress = (body: DeliveryAddress) => {
  const { mutateAsync: updateDeliveryAddress, ...result } = useMutation({
    mutationFn: (variables: DeliveryAddress) =>
      DeliveryAddressApi.updateDeliveryAddress(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateDeliveryAddress, ...result };
};

/**
 * [DeliveryAddress] 배달 주소 삭제
 * --
 */
export const useDeleteDeliveryAddress = (idx: number) => {
  const { mutateAsync: deleteDeliveryAddress, ...result } = useMutation({
    mutationFn: (variables: number) =>
      DeliveryAddressApi.deleteDeliveryAddress(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteDeliveryAddress, ...result };
};
